import {db} from './db.js';
import {getValidSchoolsOptions} from './stateOptionsHelpers.js';

export function initSchools() {
  return {
    selected: null,
    options: getValidSchoolsOptions(db)
  };
}

export function initPeople() {
  return {
    selected: null,
    options: {
      teachers: [],
      staffs: []
    }
  };
}

export function initTools() {
  return {
    selected: null,
    options: {},
    selectedLabel: null
  };
}

export function initDepartments() {
  return {
    selected: null,
    options: []
  };
}

export function initGrades() {
  return {
    selected: null,
    options: []
  };
}

export function initJobTitle() {
  return null;
}

export function initState() {
  return {
    schools: initSchools(),
    people: initPeople(),
    tools: initTools(),
    departments: initDepartments(), // teacher only
    grades: initGrades(), // teacher only
    jobTitle: initJobTitle() // staff only
  };
}
